/* ---------------------------------------- [START] isInViewport */
function isInViewport(el) {
	var rect = el.getBoundingClientRect();

	var isVisible = el.offsetHeight !== 0;

	return (
		isVisible &&
		rect.bottom >= 0 &&
		rect.right >= 0 &&
		rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.left <= (window.innerWidth || document.documentElement.clientWidth)
	);
}
/* ---------------------------------------- [END] isInViewport */

/* ---------------------------------------- [START] 簡單的節流函數 */
// https://www.cnblogs.com/coco1s/p/5499469.html
function throttle(func, wait, mustRun) {
	var timeout;
	var startTime = new Date();

	return function () {
		var context = this;
		var args = arguments;
		var curTime = new Date();

		if (timeout !== undefined) {
			if (window.requestTimeout !== undefined) clearRequestTimeout(timeout);
			else clearTimeout(timeout);
		}
		// 如果達到了規定的觸發時間間隔，觸發 handler
		if (curTime - startTime >= mustRun) {
			func.apply(context, args);
			startTime = curTime;
			// 沒達到觸發間隔，重新設定定時器
		} else {
			if (window.requestTimeout !== undefined) timeout = requestTimeout(func, wait);
			else timeout = setTimeout(func, wait);
		}
	};
}
/* ---------------------------------------- [END] 簡單的節流函數 */

(function() {

	/* ---------------------------------------- [START] 整頁 Scroll 監測 (Before) */
	var pageScrollCheckList = []; // 紀錄物件
	var pageScrollAdd = function (selector, buildFunction) {
		var el = document.querySelector(selector);
		if (el === null) {
			return false;
		}
		pageScrollCheckList.push({
			build: false,
			el: el,
			fun: buildFunction,
		});
	};
	var pageScrollClean = function () {
		pageScrollCheckList = Array.prototype.filter.call(pageScrollCheckList, function (item) {
			return item.build === false;
		});
	};
	/* ---------------------------------------- [END] 整頁 Scroll 監測 (Before) */

	/* ---------------------------------------- [START] Flow  */
	const svcFlowCarousel = '#svc-flow-carousel';

	function svcFlowBuild() {
		const swiperTarget = svcFlowCarousel;
		const swiperEl = document.querySelector(swiperTarget).parentElement;
		const swiperNextEl = swiperEl.querySelector('.swiper-button-next');
		const swiperPrevEl = swiperEl.querySelector('.swiper-button-prev');

		let swiper = null;

		const swiperBuild = function() {
			swiper = new Swiper(swiperTarget, {
				slidesPerView: 'auto',
				centeredSlides: true,
				navigation: {
					nextEl: swiperNextEl,
					prevEl: swiperPrevEl,
				},
			});
		}

		const breakpoint = window.matchMedia('(min-width: 1024px)');
		const breakpointChecker = function() {
			if (breakpoint.matches) {
				// Large
				if (swiper !== undefined && swiper !== null) {
					swiper.destroy(true, true);
					swiper = null;
				}
			} else {
				// Small + Medium
				swiperBuild();
			}
		}

		// Start
		breakpoint.addListener(breakpointChecker);
		breakpointChecker();
	}
	window.addEventListener('load', function () {
		pageScrollAdd(svcFlowCarousel, svcFlowBuild);
	});
	/* ---------------------------------------- [END] Flow */
	
	/* ---------------------------------------- [START] Certifications  */
	const svcCertCarousel = '#svc-cert-carousel';

	function svcCertBuild() {
		const swiperTarget = svcCertCarousel;
		const swiperEl = document.querySelector(swiperTarget).parentElement;
		const swiperNextEl = swiperEl.querySelector('.swiper-button-next');
		const swiperPrevEl = swiperEl.querySelector('.swiper-button-prev');

		const swiper = new Swiper(swiperTarget, {
			slidesPerView: 2,
			slidesPerGroup: 2,
			spaceBetween: 15,
			lazy: true,
			preloadImages: false,
			navigation: {
				nextEl: swiperNextEl,
				prevEl: swiperPrevEl,
			},
			breakpoints: {
				640: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 5,
					slidesPerGroup: 5,
					spaceBetween: 20,
				}
			}
		});
	}
	window.addEventListener('load', function () {
		pageScrollAdd(svcCertCarousel, svcCertBuild);
	});
	/* ---------------------------------------- [END] Certifications */

	/* ---------------------------------------- [START] 整頁 Scroll 監測 (After) */
	var pageScrollThrottle = null;
	var pageScrollHandler = function () {
		if (pageScrollCheckList.length === 0) {
			return false;
		} // 因為改成 Page Global 執行，所以不會停止

		for (var i = 0; i < pageScrollCheckList.length; i++) {
			if (isInViewport(pageScrollCheckList[i].el)) {
				pageScrollCheckList[i].fun();
				pageScrollCheckList[i].build = true;
			}
		}
		pageScrollClean();
		// if (pageScrollCheckList.length === 0) {
		// 	off(window, 'scroll', pageScrollThrottle);
		// }
	};

	window.addEventListener('load', function () {
		pageScrollThrottle = throttle(pageScrollHandler, 50, 1000); // 節流作用
		window.addEventListener('scroll', pageScrollThrottle);
		pageScrollHandler();
	});
	/* ---------------------------------------- [END] 整頁 Scroll 監測 (After) */
})();
